import { useTranslation } from 'react-i18next';
import './TechnicalWorks.scss';
import { SystemStore } from '../../store/System';
import { getTimeFormatDate } from '../../utils/functions';
import { observer } from 'mobx-react';
import technicalWorksImage from '../../assets/maintenance-illustration.svg';
import React from 'react';
const chooseTimeView = (isValidDate:boolean,time:string) =>{
  return isValidDate ? '__:__' : time;
};
const TechnicalWorksPage = () => {
  const { isShowDefaultBanner } = SystemStore;
  const { startDateTime, endDateTime } = SystemStore.systemState;

  const { t } = useTranslation();
  return (
    <div className='banner-inner'>
      <div className='banner-outer'>
        <img src={technicalWorksImage} alt={'technicalWorks'}/>
        <div className={'banner-title'}>
          {t('messagesForBanners.loginMsgBanner.title')}
        </div>
        <div className={'banner-description'}>
          {t('messagesForBanners.loginMsgBanner.body',
            {timeFrom: chooseTimeView(isShowDefaultBanner, getTimeFormatDate(new Date(startDateTime))),
              timeTo: `${chooseTimeView(isShowDefaultBanner, getTimeFormatDate(new Date(endDateTime)))} ${!isShowDefaultBanner ? 'UTC+3' : ''}`})}
        </div>
        <div className={'banner-footer'}>
          {t('messagesForBanners.loginMsgBanner.footer')}
        </div>
      </div>
    </div>
  );
};

export default observer(TechnicalWorksPage);
